import {Modal, Col, Row, Form} from 'react-bootstrap';
import { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { UserContext } from '../../../UserContext';
import { validateFormFields } from '../../../utils';
import {FormInput} from '../../formElements/FormInput';
import CommonService from '../../../services/CommonService';
import CurrencyInput from '../../formElements/CurrencyInput'
import BaseService from '../../../services/BaseService';
import { Typeahead } from 'react-bootstrap-typeahead';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {FaCalendarAlt} from 'react-icons/fa';

const EditFinalSale = (props) => {
    const user = useContext(UserContext);
    const {onModalClose, finalSaleInfo} = props;
    const [formErrors, setFormErrors] = useState({});
    const [finalSale, setFinalSale] = useState({...finalSaleInfo});

    const finalSaleStatus = [
        {
            statusFlag: "C",
            statusName: "Cancelled"
        },
        {
            statusFlag: "D",
            statusName: "Draft"
        },
        {
            statusFlag: "E",
            statusName: "Edited - Resubmitted"
        },
        {
            statusFlag: "R",
            statusName: "Reviewed"
        },
        {
            statusFlag: "S",
            statusName: "Submitted"
        },
    ]

    const finalSaleRetireFlag = [
        {
            flagValue: "R",
            flagName: "Redeemed"
        },
        {
            flagValue: "P",
            flagName: "Repaid"
        },
        {
            flagValue: "M",
            flagName: "Matured"
        },
        {
            flagValue: "O",
            flagName: "Other"
        },
        {
            flagValue: "N",
            flagName: "Not Retired"
        },
    ]

    const handleFinalSaleChange = e => {
            const { name } = e.target;
            let value = e.target.value;
            setFinalSale(prevState => ({
                ...prevState, [name]: value
            }))
    }

    const handleDateChange = (e, key) => {
        setFinalSale(prevState=>({
            ...prevState, 
            [key]: e??''
        })
        )
    }

    const handleTypeaheadChange = (e, key) => {
        let selectedValue = '';
        if(key === 'issueStatusFlag') {
            selectedValue = e.length > 0 ? e[0]['statusFlag'] : "";
        }
        if(key === 'retireFlag' || key === 'mlrRetireFlag') {
            selectedValue = e.length > 0 ? e[0]['flagValue'] : "";
        }
        setFinalSale(prevState=>({
            ...prevState, 
            [key]: selectedValue
        })
        )
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.target.closest('form#edit-finalsale');
        let formErrors = validateFormFields(form.elements);
        if(Object.keys(formErrors).length > 0) {
            setFormErrors(formErrors);
        } else {  
            setFormErrors({});
            var obj = {
                msgId: null,
                sysId: null,
                opr: "putFinalSaleUpdate",
                hdrStruct: null,
                queryParam: null,
                reqData: { 
                    "finalSale" : {
                        "cdiacNbr": finalSale.cdiacNbr,
                        "finalSaleId": finalSale.finalSaleId,
                        "issuerName": finalSale.issuerName,
                        "projectName": finalSale.projectName,
                        "issueStatusFlag": finalSale.issueStatusFlag,
                        "settlementDate": finalSale.settlementDate,
                        "principalSaleAmt": finalSale.principalSaleAmt,
                        "marksRoosProceedAmt": finalSale.marksRoosProceedAmt,
                        "adtrReportableFlag": finalSale.adtrReportableFlag,
                        "retireFlag": finalSale.retireFlag,
                        "retireDate": finalSale.retireDate,
                        "mlrRetireFlag": finalSale.mlrRetireFlag,
                        "mlrRetireDate": finalSale.mlrRetireDate,
                        "finalSaleReceiveDate": finalSale.finalSaleReceiveDate,
                        "lastUpdateUser": CommonService.getUserName(user)
                    }
                },
            };
        
            BaseService.processRequest(obj)
                .then((result) => {
                    if (result.data.errors && result.data.errors.length > 0){
                            toast.error(result.data.errors[0].message)
                    }
                    else{
                        toast.success("Final Sale updated successfully!");
                        onModalClose();
                    }

                });
        }
    }
    
    return (
        <Modal show={true} backdrop="static" onHide={onModalClose}>
            <Modal.Header closeButton><h3>Edit Report of Final Sale</h3></Modal.Header>
            <Modal.Body>
            <Form id="edit-finalsale">
                <div className="contactForm">
                    <Row>
                            <Col md={4} className="control">
                                <FormInput
                                    label="CDIAC#"
                                    type="text"
                                    value={finalSale.cdiacNbr}
                                    disabled
                                    readOnly
                                />
                            </Col>
                            <Col md={8} className="control">
                                 <FormInput
                                    label="Issuer Name"
                                    type="text"
                                    value={finalSale.issuerName}
                                    disabled
                                    readOnly
                                />
                            </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="control">
                                 <FormInput
                                    label="Project Name"
                                    type="text"
                                    value={finalSale.projectName}
                                    disabled
                                    readOnly
                                />
                            </Col>
                    </Row>
                    <Row>
                             
                            <Col md={6} className="control">
                                <FormInput
                                    label="Principal Sale Amount"
                                    type="text"
                                    value={CommonService.currencyFormatter(finalSale.principalSaleAmt)}
                                    disabled
                                    readOnly
                                />
                            </Col>
                            <Col md={6} className="control">
                                <FormInput
                                    label="Settlement Date"
                                    type="text"
                                    value={CommonService.dateFormatter(finalSale.settlementDate)}
                                    disabled
                                    readOnly
                                />
                            </Col>
                    </Row>
                     <Row>
                            <Col md={6} className="control">
                                    <label><span className="required">*</span>Final Sale Status: </label>
                                    <Typeahead
                                        placeholder="Choose a Final Sale Status"
                                        id="issueStatusFlag"
                                        name="issueStatusFlag"
                                        labelKey="statusName"
                                        onChange={e => handleTypeaheadChange(e, 'issueStatusFlag')}
                                        inputProps={{ 'data-validations': 'required', name: 'issueStatusFlag' }}
                                        options={finalSaleStatus}
                                        selected={
                                            finalSaleStatus.filter(option =>
                                                option.statusFlag === finalSale.issueStatusFlag)
                                        }
                                    />
                                {formErrors.issueStatusFlag && <p className="error">Final Sale Status is required</p>}
                            </Col>
                            <Col md={6} className="control">
                                    <label><span className="required">* </span>Final Sale Received Date: </label>
                                    <div>
                                        <span>
                                            <DatePicker
                                                selected={finalSale.finalSaleReceiveDate ? new Date(finalSale.finalSaleReceiveDate) : null}
                                                dateFormat="M/d/yyyy"
                                                maxDate={new Date(9999, 12, 31)}
                                                name="finalSaleReceiveDate1"
                                                onChange={(e) => handleDateChange(e, 'finalSaleReceiveDate')}
                                            />
                                            <FaCalendarAlt className="date-picker-icon" />
                                        </span>
                                        {formErrors.finalSaleReceiveDate && <p className="error">Final Sale Received Date is required</p>}
                                        <input type="hidden" data-validations={["required"]} value={finalSale.finalSaleReceiveDate} name="finalSaleReceiveDate" />
                                    </div>
                            </Col>
                            
                    </Row>
                    <Row>
                            <Col md={12}>
                                <label><span className="required">*</span>ADTR Reportable Flag: </label>
                                <Form.Check
                                    inline
                                    label="No"
                                    name="adtrReportableFlag"
                                    value="N"
                                    type="radio"
                                    id="adtrReportableFlag_0"
                                    checked={finalSale.adtrReportableFlag === 'N'}
                                    onChange={(e)=>handleFinalSaleChange(e)}
                                />
                                <Form.Check
                                    inline
                                    label="Yes"
                                    name="adtrReportableFlag"
                                    value="Y"
                                    type="radio"
                                    id="adtrReportableFlag_1"
                                    checked={finalSale.adtrReportableFlag === 'Y'}
                                    onChange={(e)=>handleFinalSaleChange(e)}
                                />
                                {formErrors.adtrReportableFlag && <p className="error">{formErrors.adtrReportableFlag}</p>}
                            </Col>
                    </Row>
                    <Row>
                            <Col md={6} className="control">
                                    <label><span className="required">*</span>Marks-Roos Retirement Flag: </label>
                                    <Typeahead
                                        placeholder="Choose a Marks-Roos Retirement"
                                        id="retireFlag"
                                        name="retireFlag"
                                        labelKey="flagName"
                                        onChange={e => handleTypeaheadChange(e, 'retireFlag')}
                                        inputProps={{ 'data-validations': 'required', name: 'retireFlag' }}
                                        options={finalSaleRetireFlag}
                                        selected={
                                            finalSaleRetireFlag.filter(option =>
                                                option.flagValue === finalSale.retireFlag)
                                        }
                                    />
                                {formErrors.retireFlag && <p className="error">Marks-Roos Retire Flag is required</p>}
                            </Col>
                            <Col md={6} className="control">
                                    <label>Marks-Roos Retirement Date: </label>
                                    <div>
                                        <span>
                                            <DatePicker
                                                selected={finalSale.retireDate ? new Date(finalSale.retireDate) : null}
                                                dateFormat="M/d/yyyy"
                                                maxDate={new Date(9999, 12, 31)}
                                                name="retireDate1"
                                                onChange={(e) => handleDateChange(e, 'retireDate')}
                                            />
                                            <FaCalendarAlt className="date-picker-icon" />
                                        </span>
                                    </div>
                            </Col>
                    </Row>
                    <Row>
                            <Col md={6} className="control">
                                    <label><span className="required">*</span>Mello Roos Retirement Flag: </label>
                                    <Typeahead
                                        placeholder="Choose a Mello Roos Retirement"
                                        id="mlrRetireFlag"
                                        name="mlrRetireFlag"
                                        labelKey="flagName"
                                        onChange={e => handleTypeaheadChange(e, 'mlrRetireFlag')}
                                        inputProps={{ 'data-validations': 'required', name: 'mlrRetireFlag' }}
                                        options={finalSaleRetireFlag}
                                        selected={
                                            finalSaleRetireFlag.filter(option =>
                                                option.flagValue === finalSale.mlrRetireFlag)
                                        }
                                    />
                                {formErrors.mlrRetireFlag && <p className="error">Mello Roos Retire Flag is required</p>}
                            </Col>
                            <Col md={6} className="control">
                                    <label>Mello Roos Retirement Date: </label>
                                    <div>
                                        <span>
                                            <DatePicker
                                                selected={finalSale.mlrRetireDate ? new Date(finalSale.mlrRetireDate) : null}
                                                dateFormat="M/d/yyyy"
                                                maxDate={new Date(9999, 12, 31)}
                                                name="mlrRetireDate1"
                                                onChange={(e) => handleDateChange(e, 'mlrRetireDate')}
                                            />
                                            <FaCalendarAlt className="date-picker-icon" />
                                        </span>
                                    </div>
                            </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="control">
                                    <span className="required">* </span>
                                    <CurrencyInput
                                    placeholder="0.00"
                                    label="Marks Roos Proceed Amount"
                                    name="marksRoosProceedAmt"
                                    type="text"
                                    onChange={(e) => handleFinalSaleChange(e)}
                                    value={finalSale.marksRoosProceedAmt}
                                    validations={["required", "max:999999999999.99"]}
                                />
                                {formErrors['marksRoosProceedAmt'] && <span className="error">{formErrors['marksRoosProceedAmt']}</span>}

                        </Col>
                    </Row>
                </div>
                <div className="btn-div">
                <div className="fright">
                    <button type="button" className="custom-button-secondary  btn-secondary" onClick={onModalClose}>Cancel</button>{" "}
                    <button className="custom-button" type="button" onClick={(e)=>handleSubmit(e)}>Update Final Sale</button>
                    </div>
                </div>
            </Form>                
            </Modal.Body>
        </Modal>
    )
}

export default EditFinalSale
